import axios from 'axios'
import io from 'socket.io-client'
import localforage from 'localforage'
import { fpPromise } from './fingerprint'
import { useNativeDesignerSearchHn, useNativeDesignerSearchVn, useNativeDesignerSearchAn } from './designerPatientSearchModal.util'
// Creating a localForage instance
const forageStore = localforage.createInstance({
  driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE],
  name: 'ckd-cache',
})

// Adapter to integrate localForage with axios-cache-interceptor
const forageAdapter = {
  async set(key, value, currentRequest) {
    await forageStore.setItem(key, value)
  },
  async remove(key, currentRequest) {
    await forageStore.removeItem(key)
  },
  async find(key, currentRequest) {
    const item = await forageStore.getItem(key)
    return item ? item : undefined
  },
}
export const getBaseURL = () => {
  //let baseURL = import.meta.env.VITE_BASE_URL
  let baseURL = process.env.REACT_APP_BASE_URL
  if (process.env.NODE_ENV == 'development') {
    //baseURL = '//api.'+window.location.hostname
  } else {
    //Build file

    let subPath = process.env.REACT_APP_SUBPATH || ''
    let subDomain = process.env.REACT_APP_SUBDOMAIN || ''
    if (subPath == '' && subDomain == '') {
      subDomain = 'api.'
    }
    baseURL =
      window.location.protocol +
      '//' +
      subDomain +
      window.location.hostname +
      subPath
  }
  return baseURL
}

export const getDrawingURL = () => {
  //let baseURL = import.meta.env.VITE_BASE_URL
  let baseURL = process.env.REACT_APP_DRAWING_URL
  if (process.env.NODE_ENV == 'development') {
    //baseURL = '//api.'+window.location.hostname
  } else {
    //Build file
    //baseURL = '//drawing.'+window.location.hostname
    baseURL = null
  }
  return baseURL
}

export const getSocketObject = () => {
  return io.connect(getSocketURL(), {
    path: '/socket.io/private/notification',
    query: {
      token: sessionStorage.getItem('socketToken'),
    },
    withCredentials: true,
  })
}

export const getSocketURL = () => {
  let socketURL = process.env.REACT_APP_SOCKET_URL
  if (process.env.NODE_ENV == 'development') {
    //socketURL = 'wss://dev.ckd.ckhis.xyz'
  } else {
    //Build file
    let subPath = process.env.REACT_APP_SUBPATH || ''
    let subDomain = process.env.REACT_APP_SUBDOMAIN || ''
    let scheme = window.location.protocol === 'https:' ? 'wss' : 'ws'
    if (subPath == '' && subDomain == '') {
      subDomain = 'api.'
    }
    socketURL = scheme + '://' + subDomain + window.location.hostname
  }

  return socketURL
}

export const getQueueSocketURL = () => {
  let socketURL = process.env.REACT_APP_SOCKET_QUEUE_URL
  if (process.env.NODE_ENV == 'development') {
    //socketURL = 'wss://dev.ckd.ckhis.xyz/queue'
  } else {
    //Build file
    let subPath = process.env.REACT_APP_SUBPATH || ''
    let subDomain = process.env.REACT_APP_SUBDOMAIN || ''
    let scheme = window.location.protocol === 'https:' ? 'wss' : 'ws'
    if (subPath == '' && subDomain == '') {
      subDomain = 'api.'
    }
    socketURL = scheme + '://' + subDomain + window.location.hostname
  }

  return socketURL
}

const axiosOption = {
  maxRedirects: 0,
  baseURL: getBaseURL(),
  withCredentials: true, // Set withCredentials here
  validateStatus: function (status) {
    // Resolve only if the status is in the 200 range or 302
    return (status >= 200 && status < 300) || status === 302
  },
}

const instance = axios.create(axiosOption)

const networkInstance = axios.create(axiosOption)
//const httpClient = setupCache(instance);
let clearOnLogout = []

let cacheableEndpoints = [
  '/core/locales/common/th.json',
  '/core/locales/common/en.json',
  '/core/config?systemServiceTypeCode=core&perPage=1000',
  '/core/config/configCode/AUTOSYNC_ENABLED',
  '/core/config/configCode/LABORATORY_POLICY',
  '/ipd/vital-sign-rule?*',
  '*/documents-json',
  '/designer/form-design/*',
]

let networkLaterEndpoints = [
  //"/core/config/me?systemServiceTypeCode=core&perPage=1000",
  //"/ipd/in-patient-admit/patient-dashboard?page=1&perPage=20"
]

let restoreEndpoint = { cache: [], networkLater: [] }

export const removeAllCacheableEndpoints = async () => {
  restoreEndpoint.cache = cacheableEndpoints
  restoreEndpoint.networkLater = networkLaterEndpoints
  cacheableEndpoints = []
  networkLaterEndpoints = []
}

export const restoreAllCacheableEndpoints = async () => {
  setCacheableEndpoints(restoreEndpoint.cache)
  setNetworkLaterEndpoint(restoreEndpoint.networkLater)
}

export const getCacheableEndpoints = () => {
  return cacheableEndpoints
}

export const getNetworkLaterEndpoint = () => {
  return networkLaterEndpoints
}

export const setClearOnLogout = async (data) => {
  clearOnLogout = clearOnLogout.concat(data)
}

export const setCacheableEndpoints = async (data) => {
  cacheableEndpoints = cacheableEndpoints.concat(data)
}

export const setNetworkLaterEndpoint = async (data) => {
  networkLaterEndpoints = networkLaterEndpoints.concat(data)
}

export const setRestoreEndpoint = async (cache, networkLater) => {
  restoreEndpoint.cache = restoreEndpoint.cache.concat(cache)
  restoreEndpoint.networkLater = restoreEndpoint.networkLater.concat(
    networkLater,
  )
}

let pendingCacheRequests = {}

const escapeRegExp = (text) => {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

const createPendingCacheRequest = () => {
  let resolve
  let reject
  const promise = new Promise((onResolve, onReject) => {
    resolve = onResolve
    reject = onReject
  })
  promise.catch(() => {})

  return { promise, resolve, reject }
}

const getBaseUrlPath = () => {
  try {
    const baseUrl = axiosOption.baseURL || getBaseURL()
    if (!baseUrl) return ''

    const parsedBaseUrl = new URL(baseUrl, window.location.origin)
    return parsedBaseUrl.pathname === '/'
      ? ''
      : parsedBaseUrl.pathname.replace(/\/$/, '')
  } catch {
    return ''
  }
}

const removeBaseUrlPath = (urlText) => {
  const baseUrlPath = getBaseUrlPath()
  if (!baseUrlPath) return urlText
  if (urlText === baseUrlPath) return '/'
  if (urlText.startsWith(`${baseUrlPath}/`)) {
    return urlText.slice(baseUrlPath.length)
  }
  return urlText
}

const getRequestUrlVariants = (url) => {
  const urlText = `${url || ''}`.trim()
  if (!urlText) return []

  const variants = [urlText]
  try {
    const baseUrl = axiosOption.baseURL || getBaseURL() || window.location.origin
    const formattedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`
    const parsedUrl = new URL(urlText, formattedBaseUrl)
    const pathWithSearch = `${parsedUrl.pathname}${parsedUrl.search}`
    variants.push(removeBaseUrlPath(pathWithSearch))
    variants.push(pathWithSearch)
  } catch {
    // Keep raw URL matching when the URL cannot be parsed.
  }

  return [...new Set(variants)]
}

const createWildcardRegExp = (pattern) => {
  const regexText = pattern.split('*').map(escapeRegExp).join('.*')
  return new RegExp(`^${regexText}$`)
}

const isEndpointMatched = (url, endpoint) => {
  const endpointText = `${endpoint || ''}`.trim()
  if (!endpointText) return false

  const urlVariants = getRequestUrlVariants(url)
  const endpointVariants = getRequestUrlVariants(endpointText)

  return endpointVariants.some((endpointVariant) => {
    if (endpointVariant.includes('*')) {
      const endpointRegExp = createWildcardRegExp(endpointVariant)
      return urlVariants.some((urlVariant) => endpointRegExp.test(urlVariant))
    }

    return urlVariants.some((urlVariant) => urlVariant.includes(endpointVariant))
  })
}

const getRequestCacheKey = (url) => {
  const urlText = `${url || ''}`.trim()
  try {
    const baseUrl = axiosOption.baseURL || getBaseURL() || window.location.origin
    const formattedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`
    const parsedUrl = new URL(urlText, formattedBaseUrl)
    const pathWithSearch = `${parsedUrl.pathname}${parsedUrl.search}`
    return removeBaseUrlPath(pathWithSearch)
  } catch {
    const urlVariants = getRequestUrlVariants(url)
    return urlVariants.find((urlVariant) => urlVariant.startsWith('/')) || urlText
  }
}

const findCacheResult = async (url) => {
  const cacheKeys = getRequestUrlVariants(url)
  for (const cacheKey of cacheKeys) {
    const cacheResult = await forageAdapter.find(cacheKey)
    if (cacheResult) return cacheResult
  }
}

const createCacheResponseAdapter = (cacheResult) => {
  return (config) =>
    Promise.resolve({
      data: cacheResult,
      status: 200,
      statusText: 'OK',
      headers: config.headers,
      config,
      request: null,
    })
}

const getPendingCacheRequest = (url) => {
  return pendingCacheRequests[getRequestCacheKey(url)]
}

const setPendingCacheRequest = (url) => {
  const cacheKey = getRequestCacheKey(url)
  if (!pendingCacheRequests[cacheKey]) {
    pendingCacheRequests[cacheKey] = createPendingCacheRequest()
  }
}

const resolvePendingCacheRequest = (url, data) => {
  const cacheKey = getRequestCacheKey(url)
  if (!pendingCacheRequests[cacheKey]) return
  pendingCacheRequests[cacheKey].resolve(data)
  delete pendingCacheRequests[cacheKey]
}

const rejectPendingCacheRequest = (url, error) => {
  const cacheKey = getRequestCacheKey(url)
  if (!pendingCacheRequests[cacheKey]) return
  pendingCacheRequests[cacheKey].reject(error)
  delete pendingCacheRequests[cacheKey]
}

export const isEndpointCacheable = (url) => {
  //return cacheableEndpoints.includes(url);
  return (
    cacheableEndpoints.find((endpoint) => isEndpointMatched(url, endpoint)) !==
    undefined
  )
}

export const isNetworkLaterEndpoint = (url) => {
  //return networkLaterEndpoints.includes(url);

  return (
    networkLaterEndpoints.find((endpoint) => isEndpointMatched(url, endpoint)) !==
    undefined
  )
}

export const removeCacheItem = async (url) => {
  const cacheKeys = getRequestUrlVariants(url)
  for (const cacheKey of cacheKeys) {
    await forageAdapter.remove(cacheKey)
  }
}

export const removeCacheItemsByEndpoint = async (endpoint) => {
  const cacheKeys = await forageStore.keys()
  const matchingCacheKeys = cacheKeys.filter((cacheKey) =>
    isEndpointMatched(cacheKey, endpoint)
  )

  await Promise.all(
    matchingCacheKeys.map((cacheKey) => forageAdapter.remove(cacheKey))
  )
}

export const clearAllCache = (onsuccess = () => {}, onerror = () => {}) => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('ckd-cache-clear'))
  }

  cacheableEndpoints.forEach(async (url) => {
    await forageAdapter.remove(url)
  })

  var request = indexedDB.deleteDatabase('ckd-cache')

  request.onsuccess = function () {
    console.log('Database deleted successfully')
    onsuccess()
  }

  request.onerror = function () {
    console.log('Error deleting database')
    onerror()
  }
}

// Example endpoints to cache
const CACHEABLE_ENDPOINTS = [
  '/core/place',
  '/core/specialty', // Static reference data
  '/core/ward',
  '/designer/form-design/getByCode?code=form-admission-note', // Infrequently changed data
  '/core/patient-visit-entry-priority', // User preferences
  '/core/patient-visit-entry-type',
  '/ipd/smoking-type',
  '/ipd/alcoholic-type',
  '/designer/perspective',
]

// const cache = setupCache({
//   storage: forageAdapter, // Use the localForage adapter
//   debug: console.log
// });
const httpClient = instance
httpClient.interceptors.request.use(
  async (config) => {
    // Read a cookie value
    //config.adapter = cache.adapter
    const employeeCode = sessionStorage.getItem('sessionEmployeeCode') || ''
    config.headers['X-Employee-Code'] = employeeCode
    const fp = await fpPromise
    const result = await fp.get()
    config.headers['X-Device-Id'] = result.visitorId

    if (config.method?.toLowerCase() === 'get' && config.cache !== false) {
      //console.log("CheckInCache",config.url)
      if (isEndpointCacheable(config.url)) {
        let cacheResult = await findCacheResult(config.url)
        //console.log("cache=true",cacheResult)
        if (cacheResult) {
          //console.log("cacheRead",config.url)
          config.headers.cached = true
          config.adapter = createCacheResponseAdapter(cacheResult)
          return config
        }

        const pendingCacheRequest = getPendingCacheRequest(config.url)
        if (pendingCacheRequest) {
          try {
            cacheResult = await pendingCacheRequest.promise
            config.headers.cached = true
            config.adapter = createCacheResponseAdapter(cacheResult)
            return config
          } catch {
            return config
          }
        }

        setPendingCacheRequest(config.url)
      }
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

let hasRedirected = false
httpClient.interceptors.response.use(
  async (response) => {
    if (response.config.headers?.cached === true) {
      return useNativeDesignerSearchAn(useNativeDesignerSearchVn(useNativeDesignerSearchHn(response)))
    }

    if (response.status === 201 || response.status === 200) {
      response.status = 200
      //Cache
      if (
        response.config.method?.toLowerCase() === 'get' &&
        response.config.cache !== false
      ) {
        const contentType = response.headers['content-type']
        if (contentType?.includes('application/json')) {
          if (isEndpointCacheable(response.config.url)) {
            console.log('cacheWrite', response.config.url)
            await forageAdapter.set(
              getRequestCacheKey(response.config.url),
              response.data,
            )
            resolvePendingCacheRequest(response.config.url, response.data)
          }
        } else {
          rejectPendingCacheRequest(response.config.url, response)
          console.warn('Non-JSON response, not cached:', response.config.url)
        }
      }
    }
    return useNativeDesignerSearchAn(useNativeDesignerSearchVn(useNativeDesignerSearchHn(response)))
  },
  async (error) => {
    // Handle error
    if (
      error.response &&
      [401].includes(error.response.status) &&
      error.config?.redirectOnUnauthorized !== false
    ) {
      if (!hasRedirected) {
        hasRedirected = true
        console.log('401 Unauthorize')
        //const currentBrowserUrl = `/#/maintenance/unauthorized?rd=${encodeURIComponent(window.location.href)}`;
        const currentBrowserUrl = `${getBaseURL()}/oauth2/start?rd=${encodeURIComponent(
          window.location.href,
        )}`
        window.location.href = currentBrowserUrl
      }
    } else if (error.headers?.cached === true) {
      const config = error
      //console.log('got cached data in response, serving it directly',error);

      if (isNetworkLaterEndpoint(config.url)) {
        delete config.headers.cached
        networkInstance
          .request(config)
          .then(async (networkResponse) => {
            if (
              networkResponse.status === 200 ||
              networkResponse.status === 201
            ) {
              await forageAdapter.set(
                getRequestCacheKey(networkResponse.config.url),
                networkResponse.data,
              )
            }
          })
          .catch((networkError) => {
            console.error('Background fetch failed:', networkError)
          })
      }

      //return Promise.resolve(error);
      // Return the cached data immediately
      error.headers.cached = true
      return Promise.resolve({
        data: error.data,
        status: 200,
        statusText: 'OK',
        headers: error.headers,
        config: config,
        request: error.request,
      })
    }
    if (
      error.config?.method?.toLowerCase() === 'get' &&
      error.config?.cache !== false &&
      isEndpointCacheable(error.config.url)
    ) {
      rejectPendingCacheRequest(error.config.url, error)
    }
    return Promise.reject(error)
  },
)

export default httpClient
